/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

// --- Vue & Project imports ---
import Vue from 'vue';
import Router from '@/router/index';
import Store from '@/store/index';

// --- Services ---
import Api from '@/services/api';
import AppService from '@/services/app';

// --- Third Party imports ---
import dayjs from 'dayjs';

export default {

  login(params: { username: string, password: string }) {
    return Api(true).post('/login', params);
  },

  async checkAuth() {

    // check the local cookie to see when we timeout
    const timeoutCookie = Vue.$cookies.get('_t');

    // check if we have timed out or if we aren't logged in
    if (dayjs().isAfter(dayjs.unix(timeoutCookie)) || !Store.getters['users/loggedInUser'] || !Store.getters['users/loggedInUser'].loggedIn) {

      // if we have timed out, call the auth/me route
      try {
        const response = await Api(false).get('/auth');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            Store.dispatch('users/resetLoggedInUser');
            return response.data.message;
          } else {
            Store.dispatch('users/setLoggedInUser', {
              loggedInUser: {
                loggedIn: true,
                typeId: response.data.typeId,
                type: response.data.type,
                displayName: response.data.displayName,
                lastLogin: response.data.lastLogin,
                clearanceLevel: response.data.clearanceLevel,
              },
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }
  
      } catch (error) {
        Store.dispatch('users/resetLoggedInUser');
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('auth.ts - checkAuth - 64 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      }
    } else {
      // if we haven't timed out, carry on
      return '';
    }
  },

  logout() {
    // !!TODO empty the store
    Store.dispatch('users/resetLoggedInUser');
    
    Api(false).post('/logout').then((response) => {      
      AppService.successHandler(response.data.message);
      Router.push('/login');
    });
  },

};
